@import (reference) '../../../constants/spacing.module.less';

.form-group-scan {
  display: flex;
  gap: @space-8;
  width: 100%;
}

.scan-input {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.input-wrapper {
  position: relative;
}

.scan-error {
  padding: 2px @space-4;
  color: var(--grey-900);
}

.scan-warning {
  padding: 2px @space-4;
  color: var(--orange-700);
}

.enter-button {
  min-width: 80px;
}

.helper-text {
  margin-top: @space-8;
  color: var(--grey-600);
}

.autocomplete-scanner-icon {
  position: absolute;
  height: 16px;
  aspect-ratio: 1;
  right: @space-8;
  top: @space-8;
  z-index: 20;
}
